<template>
  <div class="sys">
    <div v-for="(item,index) in infoData" :key="index" v-html="item.NewsDesc"></div>
  </div>
</template>

<script>
export default {
  name: "sysDetails",
  data(){
    return{
      infoData:[],
    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id);
  },
  methods:{
    //获取xx
    getInfo(id){
      let data={params:{Id:id}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntNewsIdSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data;
        console.log(res.data)
      })
    },
  }
}
</script>

<style scoped>

</style>